
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from 'react';
import { css } from "styled-components";
import {StyledTypography} from "@insite/mobius/Link";

interface Option {
  value: string;
  label: string;
}

interface MultiSelectDropdownProps {
  options: Option[];
  selectedValues: Option[];
  onChange: (selectedValues: Option[]) => void;
}
export interface MultiSelectStyles {
    container?: InjectableCss;
}
 const multiSelectStyles : MultiSelectStyles= {
    container: {
        css: css`
        .multiselect-container {
            width: 355px;
          }
          
          .dropdown {
            position: relative;
            display: inline-block;
            border: 1px solid #ccc;
            cursor: pointer;
            padding: 5px;
            width:100%;
          }
          
          .selected-values {
            color: #555;
            padding: 5px;
          }
          .dropdown-arrow {
            position: absolute;
            top: 50%;
            right: 8px;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid #555;
          }
          .options {
            display: none;
            position: absolute;
            background-color: #fff;
            border: 1px solid #ccc;
            width: 250px; 
            z-index: 1;
          }
          
          .options.show {
            display: grid;
          }
          
          .option-label {
            display: block;
            padding: 5px;
            cursor:pointer;
          }
          
          .option-label:hover {
            background-color: #f0f0f0;
          }
            .option-label input[type="checkbox"] {
            margin-right: 5px;
            transform: scale(1.5); 
            }
            @media (min-width:768px) {
                .multiselect-container {
                    width: 372px;
                  }
              }
       `
    }
};

export const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({ options, selectedValues, onChange }) => {
  const [showOptions, setShowOptions] = useState(false);

  const handleCheckboxChange = (selectedOption: Option) => {
    const isSelected = selectedValues.some((option) => option.value === selectedOption.value);
    const updatedValues = isSelected
      ? selectedValues.filter((option) => option.value !== selectedOption.value)
      : [...selectedValues, selectedOption];
    onChange(updatedValues);
  };

  return (
    <StyledTypography {...multiSelectStyles.container}> 
    <div  className="multiselect-container">
      <div className="dropdown" onClick={() => setShowOptions(!showOptions)}>
        <div className="selected-values">
          {selectedValues.length === 0 ? 'Select Resources' : selectedValues.map((option) => option.label).join(', ')}
        </div>
        <div className={`options ${showOptions ? 'show' : ''}`}>
          {options.map((option) => (
            <label key={option.value} className="option-label">
              <input
                type="checkbox"
                value={option.value}
                checked={selectedValues.some((selectedOption) => selectedOption.value === option.value)}
                onChange={() => handleCheckboxChange(option)}
              />
              {option.label}
            </label>
          ))}
        </div>
        <div className="dropdown-arrow"></div>
      </div>
    </div>
    </StyledTypography>
  );
};

export default MultiSelectDropdown;